import { ref, shallowRef } from 'vue'
import { Drawer } from 'flowbite'

export const activeDrawer = ref({})
export const historyDrawer = ref([])

export const elId = 'dynamic-drawer-swipe'

export const options = {
  placement: 'bottom',
  backdrop: true,
  bodyScrolling: false,
  edge: false,
  edgeOffset: '',
  backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30',
  onHide: () => {
    console.log('drawer is hidden')
  },
  onShow: () => {
    console.log('drawer is shown')
  },
  onToggle: () => {
    console.log('drawer has been toggled')
  }
}

export const sizeClass = (size = 'md') => {
  const mapSize = {
    xs: 'h-1/3',
    sm: 'h-2/5',
    md: 'h-4/6',
    lg: 'h-5/6',
    full: 'h-full !rounded-none',
    fit: 'h-fit'
  }
  return mapSize[size]
}

export const getDrawer = () => {
  const $targetEl = document.getElementById(elId)
  const drawer = new Drawer($targetEl, options, { id: elId, override: true })
  return drawer
}

export const openBottomDrawer = (component, options = {}) => {
  const id = (Math.random() + 1).toString(36).substring(7)

  if (options.size) {
    options.size = [sizeClass(options.size)]
  }

  if (activeDrawer.value.id) {
    historyDrawer.value.push(activeDrawer.value)
  }

  activeDrawer.value = {
    id,
    comp: shallowRef(component),
    options
  }

  setTimeout(() => {
    const drawer = getDrawer()
    drawer.show()
  }, 0)
}

export const backDrawer = () => {
  if (historyDrawer.value.length > 0) {
    activeDrawer.value = historyDrawer.value.pop()
  }
}

export const closeBottomDrawer = () => {
  const drawer = getDrawer()
  historyDrawer.value = []
  activeDrawer.value = {}
  drawer.hide()
}
